// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qSzY","col":"styles_col__3_2aL"};